import { createTheme } from '@mui/material/styles';
import { themeButtonOptions } from './button.tsx';
import { primary, secondary } from './colors.tsx';
import { themeSelectOptions } from './select.tsx';
import { themeTableOptions } from './table.tsx';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: primary.main,
      light: primary.light,
      dark: primary.dark,
    },
    secondary: {
      main: secondary.main,
      light: secondary.light,
      dark: secondary.dark,
    },
    error: {
      main: '#EB3D34',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: 'sans-serif',
    fontWeightRegular: '300',
    fontSize: 16,
    h1: {
      fontFamily: 'ivyora-display',
      fontSize: '36px',
      fontWeight: '400',
      color: primary.main,
    },
    h2: {
      fontFamily: 'ivyora-display',
      fontSize: '24px',
      fontWeight: '400',
      color: primary.main,
    },
    h3: {
      fontFamily: 'ivyora-display',
      fontSize: '18px',
      fontWeight: '400',
      color: primary.main,
    },
    h4: {
      fontFamily: 'ivyora-display',
      fontSize: '16px',
      fontWeight: '400',
      color: primary.main,
    },
    h5: {
      fontFamily: 'ivyora-display',
      fontSize: '12px',
      fontWeight: '400',
      color: primary.main,
    },
  },
  components: {
    ...themeButtonOptions,
    ...themeSelectOptions,
    ...themeTableOptions,
    MuiAppBar: {
      styleOverrides: {
        root: {
          height: '64px',
        },
      },
    },
  },
});
